"use client"
import React, { useState, useEffect } from "react";
import { useConfig } from "@/lib/providers/ConfigProvider";

import "@/components/shared/AssociatedCommunities.css";
import "@/components/shared/ProfileInfoView.css";

const Communities = ({ communities }) => {
  const { webUrl } = useConfig();
  return communities.map((community, index) => {
    const communityUrl = webUrl + community.owner.resourceName;
    const separator =
      index === 0 ? " " : communities.length === index + 1 ? " and " : ", ";
    return (
      <React.Fragment key={community.id}>
        {separator}
        <a style={{ color: "#1565C0" }} key={community.id} href={communityUrl}>
          {community.owner.displayName}
        </a>
      </React.Fragment>
    );
  });
};

const AssociatedCommunities = ({ profile, communities, force = false }) => {
  const [communitiesToRender, setCommunitiesToRender] = useState([]);

  useEffect(() => {
    if (communities) {
      if (force) {
        setCommunitiesToRender(communities);
      } else {
        var communitiesIDontOwn = communities.filter(
          c => c.owner.resourceName !== profile.resourceName
        );
        setCommunitiesToRender(communitiesIDontOwn);
      }
    }
  }, [communities]);

  return (
    <>
      {communitiesToRender.length > 0 && (
        <div className="associated-communities">
          <span className="material-icons">groups</span>
          <span style={{ marginLeft: "0.25rem" }}>
            Part of
            <Communities communities={communitiesToRender} />
          </span>
        </div>
      )}
    </>
  );
};

export default AssociatedCommunities;
